import React from "react"
import { graphql } from "gatsby"
import { Icon } from "@mostlycode/ui"
import styled from "styled-components"
import Content from "components/Content"
import { valuable } from "utils/worthy"

const StyledFeatureList = styled.ul`
  list-style: none;
  margin: 1.5rem 0 0;
  padding: 1.5rem 0 2rem;
  border-top: 1px solid ${(props) => props.theme.colors.ice};
`

const StyledFeature = styled.li`
  display: grid;
  grid-template-columns: 2rem 1fr;
  grid-column-gap: 1rem;
  margin: 1rem 0;
  padding: 0;

  p {
    margin: 0;
    font-size: 1.5rem;
    line-height: 1.8;
  }

  ${(props) => props.theme.media.tablet_landscape_up`
    grid-template-columns: 3rem 1fr;
    grid-column-gap: 1.25rem;

    p {
      margin: 0;
      font-size: 1.6rem;
      line-height: 1.8;
    }
  `}
`

const StyledIcon = styled.span`
  width: 2rem;
  height: 2rem;
  background: ${(props) => props.theme.colors.kelp};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.3rem;

  svg {
    fill: ${(props) => props.theme.colors.plush};
    width: 1rem;
    height: 1rem;
  }

  ${(props) => props.theme.media.tablet_landscape_up`
    width: 2.5rem;
    height: 2.5rem;

    svg {
      fill: ${(props) => props.theme.colors.plush};
      width: 1.25rem;
      height: 1.25rem;
    }
  `}
`

function FeatureList({ features, product_theme, ...props }) {
  if (!features) return null
  return (
    <StyledFeatureList product_theme={product_theme}>
      {features.map((feature, i) =>
        valuable(feature.feature_description) ? (
          <StyledFeature key={`feature_${i}`}>
            <StyledIcon product_theme={product_theme}>
              <Icon icon="check" />
            </StyledIcon>
            <Content content={feature.feature_description} serializer={null} />
          </StyledFeature>
        ) : null
      )}
    </StyledFeatureList>
  )
}

export default FeatureList

FeatureList.defaultProps = {}
FeatureList.propTypes = {}

export const query = graphql`
  fragment FeatureListFragment on PRISMIC_ProductBodyFeature_list {
    type
    primary {
      content
    }
    features: fields {
      feature_description
    }
  }
`
